export default __webpack_public_path__ + "static/media/potion_01.b7490c62.png";